import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import DefaultSelectClient from '../../../components/default-select-client';

interface ClientGateProps {
    isClientUser: boolean;
    clientId?: number;
    onChange: (clientId: unknown) => void;
    // Explica o que depende do cliente (ex.: "para carregar os veículos de publicação")
    description: string;
    children: React.ReactNode;
}

// Usuários da empresa escolhem a entidade antes do conteúdo que depende dela; usuários de cliente nem veem o seletor
export function ClientGate({ isClientUser, clientId, onChange, description, children }: ClientGateProps) {
    if (isClientUser) return <React.Fragment>{children}</React.Fragment>;

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <Paper
                    sx={{
                        p: 2.5, display: 'flex', gap: 2, alignItems: { xs: 'stretch', md: 'center' }, flexDirection: { xs: 'column', md: 'row' },
                        border: '1px solid', borderColor: clientId ? 'divider' : 'primary.main',
                        bgcolor: clientId ? 'background.paper' : (theme) => `${theme.palette.primary.main}0A`,
                    }}
                >
                    <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flex: 1 }}>
                        <ApartmentIcon color="primary" />
                        <Box>
                            <Typography variant="subtitle1" fontWeight={600}>Entidade da remessa</Typography>
                            <Typography variant="body2" color="text.secondary">Escolha a entidade {description}.</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ width: { xs: '100%', md: 420 } }}>
                        <DefaultSelectClient required clientId={clientId} handleOnChange={(e) => onChange(e.target.value)} />
                    </Box>
                </Paper>
            </Grid>
            {clientId ? children : null}
        </React.Fragment>
    );
}
